import Link from 'next/link'

import { Button } from '@/shared/ui/Button'

import cl from './CookieAcceptation.module.scss'

type Props = {
	onAccept: () => void
}

export const CookieAcceptation = ({ onAccept }: Props): JSX.Element => {
	return (
		<aside className={cl.root}>
			<p className={cl.text}>
				Мы используем{' '}
				<Link
					prefetch={false}
					href="https://cdn.iport.ru/iport/pdf/Politika_konfidecialnosti_PT_sajt_IPort.pdf"
					target="_blank">
					cookie-файлы
				</Link>{' '}
				и{' '}
				<Link
					prefetch={false}
					href="https://cdn.iport.ru/iport/pdf/Politika_konfidecialnosti_PT_sajt_IPort.pdf"
					target="_blank">
					рекомендательные технологии
				</Link>
				, чтобы обеспечивать работу нашего сайта и делать его лучше.
			</p>
			<Button fullWidth onClick={onAccept}>
				Принять
			</Button>
		</aside>
	)
}
